const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || '';

export const showEnvBanner = !!ENVIRONMENT && ENVIRONMENT !== 'production';

export const isProduction = ENVIRONMENT === 'production';

export function EnvironmentBanner() {
  if (!showEnvBanner) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '32px',
        backgroundColor: '#EC5B13',
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontFamily: "'Public Sans', sans-serif",
        fontSize: '12px',
        lineHeight: '32px',
        zIndex: 9999,
      }}
    >
      ⚠ {ENVIRONMENT} ENVIRONMENT
    </div>
  );
}
